import { z } from 'zod';
import {
    AssetInventoryIncludeDescendantUnitAssetsSchema,
    AssetInventoryVisibilityUnrestrictedSchema,
    AssetPartyRoleKeysSchema,
} from './asset-visibility-scope.js';

const objectIdString = z.string().regex(/^[a-f0-9]{24}$/i, 'Invalid object id');

export const RoleAuthorizationEntrySchema = z.object({
    page: z.string(),
    permissions: z.array(z.string().min(1)),
    assetInventoryVisibilityUnrestricted: AssetInventoryVisibilityUnrestrictedSchema,
    assetPartyRoleKeys: AssetPartyRoleKeysSchema,
    assetInventoryIncludeDescendantUnitAssets: AssetInventoryIncludeDescendantUnitAssetsSchema,
});

const UnitRoleAssignmentSchema = z.object({
    unit: objectIdString,
    user: objectIdString.nullable().optional()
});

export const RoleSchema = z.object({
    id: z.string().optional(),
    _id: z.string().optional(),
    name: z.string().min(1, 'Role Name is required'),
    description: z.string().optional(),
    roleAuthorization: z.array(RoleAuthorizationEntrySchema).optional(),
    units: z.array(objectIdString).optional(),
    unitAssignments: z.array(UnitRoleAssignmentSchema).optional(),
    isDefault: z.boolean().optional(),
    isSystemRole: z.boolean().optional(),
    customFields: z.record(z.unknown()).optional(),
    createdAt: z.date().optional(),
    updatedAt: z.date().optional(),
});
export const CreateRoleSchema = RoleSchema.omit({ id: true, _id: true, createdAt: true, updatedAt: true });
export const UpdateRoleSchema = RoleSchema.partial();
export const RoleFormSchema = RoleSchema;

/** Body for POST /role/:id/assign-users */
export const AssignRoleUsersToRoleSchema = z.object({
    userIds: z.array(z.string().min(1)).min(1).max(200)
});

/** Body for PUT /role/:id/units (replace the unit list for a role) */
export const SetRoleUnitsSchema = z.object({
    unitIds: z.array(objectIdString).max(500)
});

/** Body for PUT /role/:id/unit-assignments */
export const SetRoleUnitAssignmentsSchema = z.object({
    assignments: z.array(UnitRoleAssignmentSchema).max(1000),
    forceReplace: z.boolean().optional(),
    /** When true, upsert provided units into existing unitAssignments (other units kept). */
    merge: z.boolean().optional(),
});

/** Body for PUT /role/:id/unit-assignment (single assignment upsert) */
export const UpsertRoleUnitAssignmentSchema = z.object({
    unit: objectIdString,
    user: objectIdString.nullable().optional(),
    forceReplace: z.boolean().optional()
});
